import React from "react";

export const CompetitionContext = React.createContext<string>("");
